<template>
  <footer class="mira-footer" :class="{ 'mira-footer--homekind': isHomekind }">
    <!-- Main Footer -->
    <div class="mira-footer__main">
      <div class="mira-footer__container">
        <div class="mira-footer__grid">
          <!-- Company Info -->
          <div class="mira-footer__col mira-footer__col--brand">
            <div v-if="isHomekind" class="mira-footer__brand mira-footer__brand--stacked">
              <HomekindLogo :size="42" />
              <span class="mira-footer__byline">oleh Miraverse.ID</span>
            </div>
            <div v-else class="mira-footer__brand">
              <img :src="logo" alt="Miraverse.ID" class="mira-footer__logo" />
              <span class="mira-footer__brand-name">
                Miraverse<span class="footer-accent">.ID</span>
              </span>
            </div>
            <p v-if="isHomekind" class="mira-footer__desc">
              Satu aplikasi untuk semua urusan rumah, dibuat untuk keluarga
              Indonesia oleh PT. Mira Bisa Berteknologi.
            </p>
            <p v-else class="mira-footer__desc">
              Pembuat Homekind, aplikasi pengelola rumah tangga untuk keluarga
              Indonesia, sekaligus partner solusi IT untuk bisnis Anda.
            </p>
            <!-- <div class="mira-footer__social">
              <a href="https://www.instagram.com" target="_blank" class="mira-footer__social-link"
                aria-label="Instagram">
                <i class="fa fa-instagram"></i>
              </a>
              <a href="https://www.linkedin.com" target="_blank" class="mira-footer__social-link" aria-label="LinkedIn">
                <i class="fa fa-linkedin"></i>
              </a>
              <a href="https://www.facebook.com" target="_blank" class="mira-footer__social-link" aria-label="Facebook">
                <i class="fa fa-facebook-f"></i>
              </a>
              <a href="https://www.youtube.com" target="_blank" class="mira-footer__social-link" aria-label="YouTube">
                <i class="fa fa-youtube"></i>
              </a>
              <a href="https://www.twitter.com" target="_blank" class="mira-footer__social-link" aria-label="Twitter">
                <i class="fa fa-twitter"></i>
              </a>
            </div> -->
          </div>

          <!-- Homekind App -->
          <div class="mira-footer__col">
            <h4 class="mira-footer__heading">Homekind App</h4>
            <ul class="mira-footer__list">
              <li><router-link to="/homekind">Ringkasan</router-link></li>
              <li><router-link to="/homekind#fitur">Fitur</router-link></li>
              <li><router-link to="/homekind#tampilan">Tampilan Aplikasi</router-link></li>
              <li><router-link to="/homekind#privasi">Peran &amp; Privasi</router-link></li>
              <li><router-link to="/homekind#harga">Harga</router-link></li>
              <li><router-link to="/homekind#faq">FAQ</router-link></li>
            </ul>
          </div>

          <!-- Solusi IT -->
          <div class="mira-footer__col">
            <h4 class="mira-footer__heading">Solusi IT</h4>
            <ul class="mira-footer__list">
              <li><router-link to="/solusi-it">Ringkasan</router-link></li>
              <li><router-link to="/about">Tentang Kami</router-link></li>
              <li><router-link to="/services">Layanan</router-link></li>
              <li><router-link to="/projects">Proyek</router-link></li>
              <li><router-link to="/contact">Kontak</router-link></li>
            </ul>
          </div>

          <!-- Contact -->
          <div class="mira-footer__col">
            <h4 class="mira-footer__heading">Hubungi Kami</h4>
            <ul class="mira-footer__contact-list">
              <li>
                <i class="fa fa-map-marker"></i>
                <span>PT. Mira Bisa Berteknologi<br>Citra Maja City, Cluster Vimala M16/01, Maja Baru, Lebak
                  Banten 42382, Indonesia</span>
              </li>
              <li>
                <i class="fa fa-whatsapp"></i>
                <span><a class="custom-link" href="https://wa.me/628114938580">+62 8114938580</a></span>
              </li>
              <li>
                <i class="fa fa-envelope"></i>
                <span><a class="custom-link" href="mailto:info@miraverse.id">info@miraverse.id</a></span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- Bottom Bar -->
    <div class="mira-footer__bottom">
      <div class="mira-footer__container">
        <div class="mira-footer__bottom-inner">
          <p>
            &copy; {{ currentYear }} PT. Mira Bisa Berteknologi. All rights
            reserved.
          </p>
          <div class="mira-footer__bottom-links">
            <router-link to="/privacy">Kebijakan Privasi</router-link>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import HomekindLogo from "@/components/homekind/HomekindLogo";

export default {
  name: "FooterComponent",
  components: { HomekindLogo },
  data() {
    return {
      logo: require("@/assets/images/logo-mira.png"),
    };
  },
  computed: {
    isHomekind() {
      return this.$route.path === "/homekind";
    },
    currentYear() {
      return new Date().getFullYear();
    },
  },
};
</script>

<style scoped lang="scss">
.mira-footer {
  background: #0f0520;
  color: rgba(255, 255, 255, 0.7);
}

.mira-footer__container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

.mira-footer__main {
  padding: 80px 0 40px;
}

.mira-footer__grid {
  display: grid;
  grid-template-columns: 1.5fr 1fr 1fr 1.2fr;
  gap: 48px;
}

.mira-footer__brand {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
}

.mira-footer__logo {
  height: 42px;
}

.mira-footer__brand-name {
  font-family: "Plus Jakarta Sans", sans-serif;
  font-size: 1.2rem;
  font-weight: 700;
  color: #fff;

  .footer-accent {
    color: #c73468;
  }
}

.mira-footer__desc {
  font-size: 0.9rem;
  line-height: 1.7;
  margin-bottom: 24px;
  color: rgba(255, 255, 255, 0.55);
}

.mira-footer__social {
  display: flex;
  gap: 10px;
}

.mira-footer__social-link {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.06);
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.9rem;
  transition: all 0.3s ease;
  text-decoration: none;

  &:hover {
    background: linear-gradient(135deg, #6c2973, #c73468);
    color: #fff;
    transform: translateY(-2px);
  }
}

.mira-footer__heading {
  color: #fff;
  font-size: 1.05rem;
  font-weight: 700;
  margin-bottom: 24px;
  position: relative;

  &::after {
    content: "";
    position: absolute;
    bottom: -8px;
    left: 0;
    width: 30px;
    height: 2px;
    background: linear-gradient(90deg, #c73468, transparent);
  }
}

.mira-footer__list {
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    margin-bottom: 10px;
  }

  a {
    color: rgba(255, 255, 255, 0.55);
    font-size: 0.9rem;
    text-decoration: none;
    transition: all 0.25s ease;
    display: inline-block;

    &:hover {
      color: #c73468;
      transform: translateX(4px);
    }
  }
}

.mira-footer__contact-list {
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    display: flex;
    gap: 12px;
    margin-bottom: 16px;
    font-size: 0.9rem;
    color: rgba(255, 255, 255, 0.55);

    i {
      color: #c73468;
      font-size: 0.9rem;
      margin-top: 4px;
      flex-shrink: 0;
    }
  }
}

.mira-footer__bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  padding: 20px 0;
}

.mira-footer__bottom-inner {
  display: flex;
  justify-content: space-between;
  align-items: center;

  p {
    font-size: 0.85rem;
    color: rgba(255, 255, 255, 0.4);
    margin: 0;
  }
}

.mira-footer__bottom-links {
  a {
    color: rgba(255, 255, 255, 0.4);
    font-size: 0.85rem;
    text-decoration: none;
    transition: color 0.2s ease;

    &:hover {
      color: #c73468;
    }
  }
}

.custom-link {
  color: inherit;
}

@media (max-width: 991px) {
  .mira-footer__grid {
    grid-template-columns: 1fr 1fr;
    gap: 40px;
  }
}

@media (max-width: 576px) {
  .mira-footer__grid {
    grid-template-columns: 1fr;
    gap: 32px;
  }

  .mira-footer__main {
    padding: 50px 0 30px;
  }

  .mira-footer__bottom-inner {
    flex-direction: column;
    gap: 10px;
    text-align: center;
  }
}
// ===== Homekind theme (home page) =====
.mira-footer__brand--stacked {
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
}

.mira-footer__byline {
  font-size: 0.8rem;
  color: rgba(246, 241, 231, 0.5);
}

.mira-footer--homekind {
  background: $hk-forest-night;
  color: rgba(246, 241, 231, 0.7);

  .mira-footer__desc,
  .mira-footer__list a,
  .mira-footer__contact-list li {
    color: rgba(246, 241, 231, 0.6);
  }

  .mira-footer__heading {
    color: $hk-linen;
    font-family: $hk-font-heading;

    &::after {
      background: linear-gradient(90deg, $hk-apricot, transparent);
    }
  }

  .mira-footer__list a:hover,
  .mira-footer__bottom-links a:hover,
  .mira-footer__contact-list i {
    color: $hk-apricot-light;
  }

  .mira-footer__bottom {
    border-top-color: rgba(246, 241, 231, 0.08);
  }
}
</style>
